//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  mdiTrayArrowUp,
  mdiDotsVertical,
  mdiCircle,
  mdiMapMarker,
  mdiCancel,
  mdiCloseCircleOutline,
  mdiPlay,
  mdiStarOutline,
  mdiVideo,
  mdiPencil,
  mdiMovieOpenPlayOutline,
  mdiHelpCircleOutline,
  mdiClose,
  mdiVideoOutline,
  mdiMessageText,
  mdiSeal,
} from '@mdi/js'
import {
  ref, computed, watch, onMounted, getCurrentInstance,
} from '@vue/composition-api'
import {
  useRouter,
  openTab,
  defaultDownloadAppByOS,
  isDev,
  formatCurrency,
  formatStdDate,
  customDeepLink,
} from '@core/utils'
import themeConfig from '@themeConfig'
import { useUtils } from '@core/libs/i18n'
import { avatarText } from '@core/utils/filter'
import {
  logUserActivity, getMatchGameCode, getMatchGameOpenCode, putHoldCardReservation, leaveMatchUser, joinMatchUser,
} from '@api'
import useCryptoJs from '@core/utils/useCryptoJs'
import useLogData from '@core/utils/useLogData'
import {
  showSuccess, showError,
} from '@/@core/utils/toasted'
import store from '@/store'

import JoinedMatch from '@/views/pickup/components/joined-match/JoinedMatch.vue'
import LeaveMatch from '@/views/pickup/components/leave-match/LeaveMatch.vue'
import AppBarUserAvatar from '@core/layouts/components/app-bar/AppBarUserAvatar.vue'
import InfoCard from '@/views/pickup/components/info-card/InfoCard.vue'
import ActionCard from '@/views/pickup/components/action-card/ActionCard.vue'
import ResultsCard from '@/views/pickup/components/results-card/ResultsCard.vue'
import VideoCard from '@/views/pickup/components/video-card/VideoCard.vue'
import PlayerList from '@/views/pickup/components/player-list/PlayerList.vue'
import FacilityCard from '@/views/pickup/components/facility-card/FacilityCard.vue'
import DownloadApp from '@/views/reservation/components/download-app/DownloadApp.vue'
import Share from '@/views/components/share/Share.vue'

import usePickup from './usePickup'

export default {
  name: 'Pickup',
  components: {
    AppBarUserAvatar,
    PlayerList,
    DownloadApp,
    InfoCard,
    ActionCard,
    ResultsCard,
    VideoCard,
    FacilityCard,
    Share,
    JoinedMatch,
    LeaveMatch,
  },
  setup() {
    const vm = getCurrentInstance().proxy
    const { route, router } = useRouter()
    const { t, tInContext } = useUtils()
    const { userData } = useCryptoJs()
    const { logData, updateLogData, clearLogData } = useLogData()
    const {
      paymentMethods, mapTeams, getTeamName, getTeamShield,
    } = usePickup()

    const USER_ACT_VISIT_MATCH_LANDING_APP = 'Visit Match Landing App'
    const USER_ACT_SHARE_MATCH_LANDING_APP = 'Share Match Landing App'
    const USER_ACT_VIEW_MATCH_LANDING_APP = 'View Match Landing App'
    const ipAddress = ref({})
    const slotSelected = ref(-1)
    const notifyNewSlot = ref(false)
    const joinedMessageFrom = ref(null)
    const userLogged = ref(null)

    const dataLanding = ref({})
    const dataComputed = computed(() => dataLanding.value)
    const computedDisabled = computed(() => (dataComputed.value.is_challenge === 'Y' && (dataComputed.value.is_joined || !dataComputed.value.can_join)) || (dataComputed.value.is_challenge === 'N' && (dataComputed.value.is_joined || dataComputed.value.match_status !== 'N')))
    const showComplexComputed = computed(
      () => dataComputed.value.complex_images
        && dataComputed.value.complex_images.length
        && dataComputed.value.complex_description,
    )
    const activeComputed = computed(() => dataComputed.value.match_status === 'Active')
    const basicComputed = computed(() => dataComputed.value.match_status === 'Basic')
    const cancelledComputed = computed(() => dataComputed.value.match_status === 'Cancelled')
    const depositCardComputed = computed(() => {
      if (dataComputed.value.deposit_card && dataComputed.value.deposit_card.ending4) return dataComputed.value.deposit_card.ending4

      return ''
    })
    const matchCode = ref(null)
    const matchId = ref(null)
    const videoId = ref(null)
    const privateLanding = ref(false)
    const isDialogLeave = ref(false)
    const isDialogJoined = ref(false)
    const isDialogDownload = ref(false)
    const isDialogPay = ref(false)
    const isDialogShare = ref(false)

    // remove chanllenge
    const teamSelected = ref(null)
    const teamsComputed = computed(() => {
      if (!dataComputed.value.players_team_a && !dataComputed.value.players_team_b) return []

      const myTeamsss = mapTeams(
        dataComputed.value.players_team_a,
        dataComputed.value.players_team_b,
        dataComputed.value.is_challenge === 'Y' ? teamSelected.value : dataComputed.value.my_team,
        dataComputed.value.my_team,
        dataComputed.value.teams || [],
      )

      return myTeamsss
    })

    const logged = computed({
      get: () => store.state.auth.logged,
      set: value => {
        store.commit('appConfig/UPDATE_FOOTER_TYPE', value)
      },
    })

    const openUpdateShare = async val => {
      isDialogShare.value = val
    }

    const openUpdatePay = async val => {
      isDialogPay.value = val
    }

    const openUpdateLeave = async val => {
      isDialogLeave.value = val
    }

    const openUpdateJoined = async val => {
      isDialogJoined.value = val
    }

    const openUpdateDownload = async val => {
      isDialogDownload.value = val
    }

    const goToPayBooking = () => {
      router.push({ name: 'pay-booking', params: { code: matchCode.value, selected: slotSelected.value, team: teamSelected.value } })
    }

    const goToProfilePicture = () => {
      router.push({
        name: 'profile-picture',
        params: {
          code: matchCode.value,
          selected: slotSelected.value,
          team: teamSelected.value,
          joined: true,
          joinedFrom: 'pay-booking',
        },
      })
    }

    const fetchMatch = async () => {
      let response = null
      if (userLogged.value) {
        if (teamSelected.value) {
          response = await getMatchGameCode(matchCode.value, teamSelected.value)
        } else {
          response = await getMatchGameCode(matchCode.value)
        }
      } else if (teamSelected.value) {
        response = await getMatchGameOpenCode(matchCode.value, teamSelected.value)
      } else {
        response = await getMatchGameOpenCode(matchCode.value)
      }
      if (response.ok) {
        dataLanding.value = response.data
        const {
          joined, joinedMessage, joinedFrom, selected, pay,
        } = route.value.params

        // remove chanllenge
        const finded = [...dataLanding.value.players_team_a, ...dataLanding.value.players_team_b].find(e => e.selected)
        if (computedDisabled.value) slotSelected.value = -1
        else if (selected) slotSelected.value = selected
        else if (finded && !dataLanding.is_joined) slotSelected.value = finded.slot
        else slotSelected.value = -1

        // remove team dataLanding.value.is_challenge === 'N' &&
        if (dataLanding.value.is_challenge === 'N' && userLogged.value && pay && dataLanding.value.can_join) {
          // slotSelected.value = selected

          // remove team
          goToPayBooking()
        }

        // remove team
        if (dataLanding.value.is_challenge === 'Y' && userLogged.value && pay && !dataLanding.value.is_joined) {
          // remove team
          if (!dataLanding.value.can_join_free) goToPayBooking()

          if (dataLanding.value.can_join_free) {
            const resp = await joinMatchUser(matchCode.value, { slot: selected })

            // eslint-disable-next-line no-use-before-define
            if (resp.ok) await initGame()
          }
        }

        if (joined && dataLanding.value.is_joined) {
          notifyNewSlot.value = joinedMessage
          joinedMessageFrom.value = joinedFrom
          openUpdateJoined(true)
        }
        matchId.value = dataLanding.value.match_id
        videoId.value = dataLanding.value.video_id

        // remove chanllenge
        if (!dataLanding.value.is_joined) {
          if (dataLanding.value.is_challenge === 'Y') {
            let selectSlot = false
            if (teamSelected.value === 'A') {
              dataLanding.value.players_team_a.forEach(e => {
                if (e.empty) {
                  e.selectable = true
                  if (!selectSlot) {
                    selectSlot = true
                    e.selected = true
                  }
                } else e.selectable = false
              })
              // eslint-disable-next-line no-return-assign
              dataLanding.value.players_team_b.map(e => e.selectable = false)
            } else if (teamSelected.value === 'B') {
              dataLanding.value.players_team_b.forEach(e => {
                if (e.empty) {
                  e.selectable = true
                  if (!selectSlot) {
                    selectSlot = true
                    e.selected = true
                  }
                } else e.selectable = false
              })
              // eslint-disable-next-line no-return-assign
              dataLanding.value.players_team_a.map(e => e.selectable = false)
            } else {
              dataLanding.value.players_team_a.forEach(e => {
                if (e.empty) {
                  e.selectable = true
                  if (!selectSlot) {
                    selectSlot = true
                    e.selected = true
                  }
                } else e.selectable = false
              })
              dataLanding.value.players_team_b.forEach(e => {
                if (e.empty) {
                  e.selectable = true
                  if (!selectSlot) {
                    selectSlot = true
                    e.selected = true
                  }
                } else e.selectable = false
              })
            }
          } else {
            // eslint-disable-next-line array-callback-return
            dataLanding.value.players_team_a.map(e => {
              if (e.empty) e.selectable = true
              else e.selectable = false
            })
            // eslint-disable-next-line array-callback-return
            dataLanding.value.players_team_b.map(e => {
              if (e.empty) e.selectable = true
              else e.selectable = false
            })
          }
        }
      } else {
        router.replace({
          name: 'match-not-found',
          params: {
            inactive: false,
            invalid: true,
          },
        })
      }
    }

    const onLogin = async (pay = false) => {
      logData.value.joinGame = 'NO'
      logData.value.matchCode = matchCode.value

      logData.value.slot = slotSelected.value
      logData.value.pay = pay
      logData.value.redirect = 'landing'
      logData.value.field = 'all'
      logData.value.date = 'all'
      logData.value.time = 'all'

      // remove team
      logData.value.team = teamSelected.value
      await updateLogData(logData.value)

      router.push({ name: 'auth-login-phone-email' })
    }

    const fetchLogUserActivity = async action => {
      await logUserActivity({
        ip_address: privateLanding.value ? null : ipAddress.value.ip,
        user_id: privateLanding.value ? userData.value.user_id : null,
        match_code: matchCode.value,
        reference: null,
        action,
      })
    }

    const linkVideo = (isVideo = false) => {
      customDeepLink(
        isVideo ? 'video' : 'match',
        isVideo ? videoId.value : matchId.value,
      )

      openUpdateDownload(true)
    }

    const formatTime = time => {
      const [min] = time.split('mins')

      return `${min} mins`
    }

    const onPay = async value => {
      const resp = await putHoldCardReservation(matchCode.value, value)
      if (resp.ok) {
        openUpdatePay(false)
        await fetchMatch()
      } else showError(resp.message.text)
    }

    const initGame = async () => {
      await clearLogData()

      userLogged.value = await JSON.parse(localStorage.getItem('userData'))
      privateLanding.value = !!userLogged.value

      // remove team
      const { code, team } = route.value.params

      matchCode.value = code

      // remove chanllenge
      teamSelected.value = `${team}`.toUpperCase()
      localStorage.setItem('matchCode', JSON.stringify(code))

      await fetchMatch()

      if (!userLogged.value) {
        await fetch('https://api.ipify.org/?format=json')
          .then(ipResponse => ipResponse.json())
          .then(async ipData => {
            ipAddress.value = ipData
          })
      }
    }

    const onPayBooking = async () => {
      if (privateLanding.value) {
        // remove team
        if (slotSelected.value > -1) {
          if (dataComputed.value.can_join_free) {
            const resp = await joinMatchUser(matchCode.value, { slot: slotSelected.value })
            if (resp.ok) {
              if (userData.value.avatar === null || userData.value.avatar.includes('no-profile-pic')) {
                goToProfilePicture()
              } else await initGame()
            }
          } else {
            goToPayBooking()
          }
        }
      } else {
        onLogin(true)
      }
    }

    const onLeave = async () => {
      const resp = await leaveMatchUser(matchCode.value)
      const msg = tInContext('game.leaved_match', vm)
      if (resp.ok) {
        await initGame()
        openUpdateLeave(false)
        showSuccess(msg)
      } else {
        showError(resp.message.text)
      }
    }

    const onLogout = async () => {
      await localStorage.removeItem('userData')
      paymentMethods.value = []

      await initGame()
    }

    watch([logged], async () => {
      await initGame()
    })

    onMounted(async () => {
      await initGame()
    })

    return {
      USER_ACT_VISIT_MATCH_LANDING_APP,
      USER_ACT_SHARE_MATCH_LANDING_APP,
      USER_ACT_VIEW_MATCH_LANDING_APP,
      ipAddress,
      userData,
      isDev,
      paymentMethods,
      matchId,
      videoId,
      slotSelected,

      // remove chanllenge
      teamSelected,
      notifyNewSlot,
      joinedMessageFrom,
      userLogged,
      teamsComputed,

      matchCode,
      privateLanding,
      isDialogLeave,
      isDialogJoined,
      isDialogDownload,
      isDialogPay,
      isDialogShare,

      dataComputed,
      computedDisabled,
      depositCardComputed,
      showComplexComputed,
      activeComputed,
      basicComputed,
      cancelledComputed,

      appLogoTitle: themeConfig.app.logoTitleBlack,

      avatarText,
      openTab,
      onLogin,
      linkVideo,
      customDeepLink,
      fetchMatch,
      openUpdateDownload,
      openUpdatePay,
      openUpdateShare,
      openUpdateLeave,
      openUpdateJoined,
      fetchLogUserActivity,
      onLogout,
      onPayBooking,
      onPay,
      defaultDownloadAppByOS,
      formatTime,
      formatCurrency,
      mapTeams,
      getTeamName,
      getTeamShield,
      formatStdDate,
      onLeave,

      t,

      icons: {
        mdiTrayArrowUp,
        mdiDotsVertical,
        mdiCircle,
        mdiMapMarker,
        mdiCancel,
        mdiCloseCircleOutline,
        mdiPlay,
        mdiStarOutline,
        mdiVideo,
        mdiPencil,
        mdiMovieOpenPlayOutline,
        mdiHelpCircleOutline,
        mdiClose,
        mdiVideoOutline,
        mdiMessageText,
        mdiSeal,
        level: require('@/assets/images/svg/level.svg'),
        levelRanked: require('@/assets/images/svg/level-ranked.svg'),
        video: require('@/assets/images/svg/video.svg'),
        seal: require('@/assets/images/svg/seal.svg'),
        teamShield: require('@/assets/images/svg/team-shield.svg'),
        ranking: require('@/assets/images/svg/ranking.svg'),
      },
    }
  },
}
